import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

export const grey = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

export const primary = {
  lighter: '#ECF2FF',
  light: '#D9E4FF',
  main: '#1E5EFF',
  dark: '#336DFF',
  darker: '#4F81FF',
  contrastText: '#FFFFFF',
};

export const secondary = {
  lighter: '#A75EF1', // Secondary 30
  light: '#9645E9', // Secondary 40
  main: '#8125DF', // Secondary 100
  dark: '#6E0BD4', // Secondary 90
  darker: '#4F81FF', // Secondary 80
  contrastText: '#FFFFFF',
};

export const info = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#DAF9EC', // Green 30
  light: '#C4F8E2', // Green 40
  main: '#1FD286', // Green 90
  dark: '#00A561', // Green 100
  darker: '#26E191', // Green 80
  contrastText: '#FFFFFF',
};

export const warning = {
  lighter: '#FFF9E1', // Yellow 30
  light: '#FFF4C9', // Yellow 40
  main: '#F99600', // Yellow 100
  dark: '#FFC700', // Yellow 90
  darker: '#FFD613', // Yellow 80
  contrastText: '#fff',
};

export const error = {
  lighter: '#FDE7EA', // Red 30
  light: '#FCD5D9', // Red 40
  main: '#FD142F', // Red 100
  dark: '#F12B43', // Red 90
  darker: '#F34359', // Red 80
  contrastText: '#FFFFFF',
};

export const green = {
  main: '#4CAF50',
  light: '#81C784',
  dark: '#388E3C',
  contrastText: '#fff',
};
export const yellow = {
  main: '#FFEB3B',
  light: '#FFF176',
  dark: '#FBC02D',
  contrastText: '#000',
};
export const red = {
  main: '#F44336',
  light: '#E57373',
  dark: '#D32F2F',
  contrastText: '#fff',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
  mainBg: '#131523',
};

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  green,
  yellow,
  red,
  common,
  divider: alpha(grey[500], 0.2),
  action,
};

// ----------------------------------------------------------------------

export function palette() {
  return {
    ...base,
    mode: 'light',
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    background: {
      paper: '#FFFFFF',
      default: grey[100],
      neutral: grey[200],
    },
    action: {
      ...base.action,
      active: grey[600],
    },
  };
}
